import React, { useState } from "react";
import server from "api/server";
import { handleImage } from "helpers/functions";
import { FormattedMessage } from "react-intl";
import removeImg from "assets/svgs/close.svg";
import imageUpload from "assets/svgs/imageUpload.svg";

const VideoUpload = ({ selectedVideo, setSelectedVideo }) => {
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await server().post("/upload", formData);
      setSelectedVideo({
        preview: null,
        path: process.env.REACT_APP_URL + data.data.file.path,
      });
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (e) => {
    e.preventDefault();
    setSelectedVideo({ preview: null, path: "" });
  };

  const videoSrc = selectedVideo?.preview
    ? URL.createObjectURL(selectedVideo.preview)
    : selectedVideo?.path
    ? handleImage(selectedVideo.path)
    : null;

  if (uploading) {
    return (
      <div
        className="image-uploader image-contain"
        style={{ minHeight: 180, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12 }}
      >
        <div className="spinner-border text-primary" role="status" />
        <span style={{ fontSize: 13, opacity: 0.7 }}>
          <FormattedMessage id="uploading" />
        </span>
      </div>
    );
  }

  if (videoSrc) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ position: "relative", display: "inline-block" }}>
          <video
            src={videoSrc}
            controls
            style={{ width: "100%", maxHeight: 280, borderRadius: 8, display: "block", background: "#000" }}
          />
          <button
            className="removeImg"
            onClick={handleRemove}
            style={{ position: "absolute", top: 8, right: 8 }}
          >
            <img src={removeImg} alt="remove" />
          </button>
        </div>
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            cursor: "pointer",
            fontSize: 13,
            opacity: 0.75,
            alignSelf: "flex-start",
          }}
        >
          <input accept="video/*" type="file" onChange={handleChange} style={{ display: "none" }} />
          <FormattedMessage id="changeVideo" />
        </label>
      </div>
    );
  }

  return (
    <div className="image-uploader image-contain">
      <label style={{ cursor: "pointer", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <input accept="video/*" type="file" onChange={handleChange} style={{ display: "none" }} />
        <div className="img-pat">
          <img src={imageUpload} width={46} height={46} alt="" />
        </div>
        <span style={{ fontSize: 13, opacity: 0.7 }}>
          <FormattedMessage id="uploadVideo" />
        </span>
      </label>
    </div>
  );
};

export default VideoUpload;
